import type React from 'react';

/**
 * Mouse-enter handler that shows a native title tooltip only when
 * the element's content is visually truncated (via `truncate` or `line-clamp-*`).
 * Uses the native `title` attribute — no React state or re-renders.
 */
export function handleTruncationTooltip(
	e: React.MouseEvent<HTMLElement>,
): void {
	const el = e.currentTarget;
	// scrollWidth > clientWidth catches single-line `truncate` (text-overflow: ellipsis)
	// scrollHeight > clientHeight catches multi-line `line-clamp-*`
	const isTruncated =
		el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

	if (isTruncated) {
		el.title = el.textContent ?? '';
	} else {
		el.removeAttribute('title');
	}
}
